import { FC, memo } from 'react';
import { CampaignSummaryItemField } from './types';

type CampaignSummaryContentProps = {
  data: CampaignSummaryItemField[] | undefined;
};

export const CampaignSummaryContent: FC<CampaignSummaryContentProps> = ({ data }) => {
  if (!data) {
    return null;
  }

  return (
    <ul className='flex flex-col'>
      {data.map(({ field, value }) => (
        <CampaignSummaryContentItem key={field} field={field} value={value} />
      ))}
    </ul>
  );
};

type CampaignSummaryContentItemProps = CampaignSummaryItemField;

const CampaignSummaryContentItem = memo(({ field, value }: CampaignSummaryContentItemProps) => (
  <li className='flex gap-1 overflow-hidden border-b border-black-100/10 py-1 text-sm *:first-letter:capitalize'>
    <p className='font-semibold text-primary-900 shrink-0'>{field}:</p>
    <p className='text-tertiary-600 truncate'>{value}</p>
  </li>
));
